module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/product-block-capacity-statistics/product-block-capacity-statistics.component.scss
// module id = ./src/app/modules/common-module/components/product-block-capacity-statistics/product-block-capacity-statistics.component.scss
// module chunks = 9